<template>
  <a-modal
    :title="formTitle || '新增字典数据'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
    >
      <a-form-model-item label="字典类型" prop="dictType">
        <a-input v-model:value="form.dictType" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item label="数据标签" prop="dictLabel">
        <a-input v-model:value="form.dictLabel" placeholder="请输入数据标签" />
      </a-form-model-item>
      <a-form-model-item label="数据键值" prop="dictValue">
        <a-input v-model:value="form.dictValue" placeholder="请输入数据键值" />
      </a-form-model-item>
      <a-form-model-item label="显示排序" prop="dictSort">
        <a-input-number
          v-model:value="form.dictSort"
          :min="0"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model:value="form.status" button-style="solid">
          <a-radio-button
            v-for="(d, index) in statusOptions"
            :key="index"
            :value="parseInt(d.value)"
          >
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input
          v-model:value="form.remark"
          placeholder="请输入内容"
          type="textarea"
          allow-clear
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button class="cancel-btn" @click="cancel"> 取消 </a-button>

          <a-button class="save-btn" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'

import { getData, addData, updateData } from '@/api/system/dict/data'

export default {
  name: 'CreateDataForm',
  props: {
    dictType: {
      type: String,
      required: false,
      default: '',
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        dictLabel: undefined,
        dictValue: undefined,
        dictSort: 0,
        status: 1,
        remark: undefined,
      },
      open: false,
      rules: {
        dictLabel: [
          { required: true, message: '数据标签不能为空', trigger: 'blur' },
        ],
        dictValue: [
          { required: true, message: '数据键值不能为空', trigger: 'blur' },
        ],
        dictSort: [
          { required: true, message: '数据顺序不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  created() {},
  computed: {},
  watch: {},
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        dictLabel: undefined,
        dictValue: undefined,
        dictSort: 0,
        status: 1,
        remark: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      if (!this.dictType) {
        this.$message.warning('字典类型不能为空')
        return
      }
      this.reset()
      this.open = true
      this.formTitle = '添加字典数据'
      this.form.dictType = this.dictType
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      const dictCode = row.id
      getData(dictCode).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改字典数据'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateData(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.$store.dispatch('dict/removeDict', this.dictType)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addData(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.$store.dispatch('dict/removeDict', this.dictType)
                this.open = false
                $emit(this, 'ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0 !important;
}
</style>

<style>
/* Modal body 样式 */
.create-form-modal .ant-modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 16px 60px 16px !important;
}

.create-form-modal .ant-form-item {
  margin-bottom: 16px;
}

.create-form-modal .ant-form-item-label {
  padding-bottom: 6px;
  flex: 0 0 150px !important;
}

.create-form-modal .ant-form-item-label > label {
  height: 32px;
  line-height: 32px;
}

.create-form-modal .ant-form-item-control {
  flex: 1 1 auto;
  line-height: 32px;
}

/* 输入框圆角样式 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
}

.create-form-modal textarea.ant-input {
  border-radius: 4px !important;
}

.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
}

/* Radio Button 样式 - 圆角和激活背景颜色 */
.create-form-modal .ant-radio-button-wrapper {
  border-radius: 4px !important;
}

.create-form-modal .ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px !important;
}

.create-form-modal .ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0 !important;
}

.create-form-modal .ant-radio-button-wrapper-checked {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:focus-within {
  box-shadow: none !important;
  outline: none !important;
}

.create-form-modal .ant-radio-button-wrapper-checked::before {
  background-color: #165DFF !important;
}

.create-form-modal .ant-radio-button-wrapper-checked:active {
  border-color: #165DFF !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>
